import PosthogService from '~/services/posthog/PosthogService';

export interface IDashboardScheduledShiftClickedPayload {
  shiftCount: number;
}

export function fireDashboardScheduledShiftClicked(payload: IDashboardScheduledShiftClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:dashboard:scheduled_shift_clicked', {
    shift_count: payload.shiftCount,
  });
}
